import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, } from '@angular/common/http';
import { AppConfig } from '../../app-config';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { Action } from 'rxjs/internal/scheduler/Action';

@Injectable({
    providedIn: 'root'
})
export class findNewSchoolsService {

    public schoolProps!: SchoolData;

    constructor(
        private httpClient: HttpClient,
        private apiUrl: AppConfig
    ) { }

   public findnewSchoolsAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.findnewSchoolsAPI, { params: filterData });
  }
  public pendingInvitesAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.pendingInvitesAPI, { params: filterData });
  }
    public pendingHistoryAPI = (filterData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.pendingHistoryAPI, { params: filterData });
  }
   public requestAction = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.teacherApiURL.requestActionAPI, requestData);
  }
    public teacherChoicesAPI = (requestData: any): Observable<any> => {
    return this.httpClient.get<any>(this.apiUrl.teacherApiURL.teacherChoicesAPI, requestData);
    }
  sendInviteAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.teacherApiURL.sendInviteAPI, requestData);
  }
  cancelInviteAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.teacherApiURL.cancelInviteAPI, requestData);
  }
  addtoSchoolAPI = (requestData: any): Observable<any> => {
    return this.httpClient.post<any>(this.apiUrl.teacherApiURL.sendInviteAPI, requestData);
  }
  
}
